var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeneral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#604DFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1 9H9.9C9.4 9 9 9.4 9 9.9V26.1C9 26.5 9.4 27 9.9 27H26.1C26.5 27 27 26.5 27 26.1V9.9C27 9.4 26.5 9 26.1 9ZM15 13H13V15H15V13ZM23 13H17V15H23V13ZM23 17H17V19H23V17ZM17 21H23V23H17V21ZM13 17H15V19H13V17ZM15 21H13V23H15V21ZM11 25H25V11H11V25Z",
    fill: "#604DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneral);
export default __webpack_public_path__ + "static/media/General.ef93545d.svg";
export { ForwardRef as ReactComponent };